import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MatCheckboxChange} from '@angular/material/checkbox';
import { MatExpansionPanel } from '@angular/material/expansion';

import {Layout} from 'plotly.js';
import {AttributeType, PlotData} from 'src/modules/types';
import {
  MONITORING_ATTR,
  POTENTIAL_ATTR,
  PROD_ALLOCATION_ATTR,
  PROD_DATA_ATTR,
  PROD_TEST_ATTR,
} from './ml-visualize.const';
import { from } from 'rxjs';

@Component({
  selector: 'wag-ml-visualize',
  styleUrls: ['./ml-visualize.component.scss'],
  template: `
    <div>
      <wag-well-graph [data]="machineLearningGraph" [layout]="machineLearningLayout"></wag-well-graph>
      <form [formGroup]="checkboxForm" class="well-filters">
      <div class="attributes-container">
        <div class="attribute-bloc">
          <p class="bloc-title">Production Data Attributes</p>
          <div class="checkbox-list">
            <mat-checkbox *ngFor="let attr of PROD_DATA_ATTR"
                          [value]="attr" formControlName="Checkbox"
                          (change)="onClickCheckbox($event, AttributeType.PRODUCTION_DATA)"
                          color="warn">{{attr.split("-", 1)}}</mat-checkbox>
          </div>
        </div>
        
        <div class="attribute-bloc">
          <p class="bloc-title">Production Monitoring Attributes</p>
          <div class="checkbox-list">
            <mat-checkbox *ngFor="let attr of MONITORING_ATTR"
                          [value]="attr" formControlName="Checkbox2"
                          (change)="onClickCheckbox($event, AttributeType.MONITORING_ATTR)"
                          color="warn">{{attr.split("-", 1)}}</mat-checkbox>
          </div>
        </div>

        <div class="attribute-bloc">
          <p class="bloc-title">Potential Attributes</p>
          <div class="checkbox-list">
            <mat-checkbox *ngFor="let attr of POTENTIAL_ATTR"
                          [value]="attr" formControlName="Checkbox3"
                          (change)="onClickCheckbox($event, AttributeType.POTENTIAL)"
                          color="warn">{{attr.split("-", 1)}}</mat-checkbox>
          </div>
        </div>
        
        <div class="attribute-bloc">
          <p class="bloc-title">Daily Production Allocation Attributes</p>
          <div class="checkbox-list">
            <mat-checkbox *ngFor="let attr of PROD_ALLOCATION_ATTR"
                          [value]="attr" formControlName="Checkbox4"
                          (change)="onClickCheckbox($event, AttributeType.PROD_ALLOCATION)"
                          color="warn">{{attr.split("-", 1)}}</mat-checkbox>
          </div>
        </div>

        <div class="attribute-bloc">
          <p class="bloc-title">Production Test Data Attributes</p>
          <div class="checkbox-list">
            <mat-checkbox *ngFor="let attr of PROD_TEST_ATTR"
                          [value]="attr" formControlName="Checkbox5"
                          (change)="onClickCheckbox($event, AttributeType.PROD_TEST_ATTR)"
                          color="warn">{{attr.split("-", 1)}}</mat-checkbox>
                          
          </div>
        </div>

        <div class="attribute-bloc" *ngIf="selectedUserFlag"  >
          <p class="bloc-title">User Added Attributes</p>
          <div class="checkbox-list" *ngIf="selectedUserAdded">
              <mat-checkbox *ngFor="let attr of selectedUserAdded"
              (change)="onClickUserAddedFeatureCheckbox($event)"
                         [value]="attr" formControlName="Checkbox6"
                        color="warn">{{attr|mlstringToJson}}</mat-checkbox> 
          </div>
        </div> 
       
        
     

      </div>
      </form>
      
    </div>
   
  `,
})
export class MlVisualizeComponent implements OnInit,OnChanges {
  @Input() machineLearningGraph!: PlotData[];
  @Input() machineLearningLayout!: Partial<Layout>;
  @Output() clickCheckbox: EventEmitter<any> = new EventEmitter<any>();
  @Output() ClickUserAddedFeature_visualization: EventEmitter<any>=new EventEmitter<any>();
  @Input() selectedUserAdded!:any[];
  selectedUserFlag:boolean=false;
  PROD_DATA_ATTR = PROD_DATA_ATTR;
  POTENTIAL_ATTR = POTENTIAL_ATTR;
  PROD_TEST_ATTR = PROD_TEST_ATTR;
  MONITORING_ATTR = MONITORING_ATTR;
  PROD_ALLOCATION_ATTR = PROD_ALLOCATION_ATTR;
  AttributeType = AttributeType;
  Eventstest:string[]=[];
  selectedUser: any[] = [];
  resposenAddedFeature: any[] = [];
  

  constructor(private formBuilder: FormBuilder) {}



    ngOnInit(): void {
      if (this.selectedUserAdded !=undefined && this.selectedUser.length>0 )
        {
          this.selectedUserFlag=true
        }
    }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedUserAdded.currentValue != undefined) {
      if (changes.selectedUserAdded.currentValue.length > 0) {
        this.resposenAddedFeature = [];
        this.selectedUserFlag = true
      }
      else {
        this.selectedUserFlag = false
      }
    }
  }

  checkboxForm: FormGroup = this.formBuilder.group({
    'Checkbox': [''],
    'Checkbox2': [''],
    'Checkbox3': [''],
    'Checkbox4': [''],
    'Checkbox5': [''],
    
  });
  clearAll(){
   this.checkboxForm.reset();
  }
  onClickCheckbox(event: MatCheckboxChange, attributeType: AttributeType): void {
    this.Eventstest.push(event.checked.toString());
    let attributeVal:any=event.source.value.split("-", 1).join("");
    this.clickCheckbox.emit({
      attribute:event.source.value,
      checked: event.checked,
      attribute_Name_Without_Unit:attributeVal,
      attributeType
    });
  }

  onClickUserAddedFeatureCheckbox(event: MatCheckboxChange) {
    if (event.checked) {
      this.resposenAddedFeature.push(event.source.value)
    }
    else {
      var elementRemove = event.source.value;
      this.resposenAddedFeature = this.resposenAddedFeature.filter(element => element !== elementRemove);
    }
    this.ClickUserAddedFeature_visualization.emit({ ColumnValue: this.resposenAddedFeature });

  }

  

}
